import { render, staticRenderFns } from "./StatusObjectBadge.vue?vue&type=template&id=79a8d72e&functional=true"
import script from "./StatusObjectBadge.vue?vue&type=script&lang=js"
export * from "./StatusObjectBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports